import Config from '@/config'

export default {
  props: {
    modelData: {
      type: Object,
      required: true,
    },
    apicad: {
      type: Boolean,
    },
    qrCode: String,
    authorData: {
      type: Object,
      required: true,
    },
    isUserAuth: Boolean,
    isIos: Boolean,
    isAndroidOs: Boolean,
  },
  data () {
    return {
      open: {
        download: false,
        auth: false
      },
      // files: {},
    }
  },
  // mounted () {
    // this.parseFiles()

  // },
  computed: {
    /**
     * Формирует новые массив с сылками на 3d модели. В каждый объект добавляется src, iosSrc и system.
     * src - ссылка на файл для модели android,
     * iosSrc - ссылка на файл для модели ios
     * system - система, на которой будет работать данный объект (если all, то на всех)
     * @return {*|*[]}
     */
    linkAr () {
      const iosArr     = [],
            androidArr = []
      if (Array.isArray(this.modelData.AndroidViewer3D) && this.modelData.AndroidViewer3D.length) {
        // this.modelData.AndroidViewer3D.push({file: 'blasf.glb', name: 'blasf.glb'})
        androidArr.push(...this.modelData.AndroidViewer3D.map(el => ( { src: el.file, system: 'android' } )))
      }
      if (Array.isArray(this.modelData.iPhoneViewer3D) && this.modelData.iPhoneViewer3D.length) {
        // this.modelData.iPhoneViewer3D.push({file: 'asd.usdz', name: 'asd.usdz'})
        iosArr.push(...this.modelData.iPhoneViewer3D.map(el => ( { iosSrc: el.file, system: 'ios' } )))
      }

      iosArr.forEach(ios => {
        androidArr.forEach(andr => {
          if (!('src' in ios) && andr.src) { // если в ios-объекте нет поля src и у andr-объекта есть поле src то
            // условие выполняется
            ios.src = andr.src // добавляем поле src в ios
            ios.system = 'all' // меняем поле системы на 'all'
            delete andr.src // удаляем поле src у андроида чтобы в следующей итерации ios этот src не задублировался
          }
        })
      })

      return [...iosArr, ...androidArr.filter(el => el.src)]

      // if (this.isAndroidOs) {
      //   return this.modelData.AndroidViewer3D || []
      // } else if (this.isIos || this.isIpad) {
      //   return this.modelData.iPhoneViewer3D || []
      // } else return []
      // return this.modelData.iPhoneViewer3D
    },
  },
  methods: {
    /**
     * Парсит файлы для блока со скачиванием модели
     * Больше не используется, блок переделан. Удалять жалко :(
     */
    // parseFiles () {
    //   if (this.modelData.files && this.modelData.files.length) {
    //     const files = [...this.modelData.files]
    //     files.sort((file) => {
    //       const nameArrA = file.name.toLowerCase().split('.'),
    //             extA     = nameArrA[nameArrA.length - 1]
    //
    //       if (extA === 'rvt' || extA === 'cad') {
    //         return -1
    //       } else return 0
    //     })
    //     this.files.first = files[0]
    //     this.files.second = files[1]
    //     this.files.others = files.length > 2 ? [...files.slice(2, files.length)] : []
    //   }
    // },
    /**
     * Конвертирует размер файлов в мегабайты или килобайты в зависимости от их размера
     * @param {number} num - текущий размер в байтах
     * @return {string} - готовая строка с размером и размерностью
     */
    convertToMegabyte (num) {
      let size = num < 1000000 ? num / 1024 : num / 1024 / 1024,
          ext  = num < 1000000 ? 'кб' : 'мб'

      return `${size.toFixed(2)} ${ext}`
    },
    /**
     * Функция открытия модального окна для скачивания. Так же тут находится проверка на авторизацию пользователя
     */
    openDownloadModal () {
      if (!this.isUserAuth) {
        this.open.auth = true
        return
      }
      this.open.download = true
    },

    /**
     * Функция открывает страницу авторизации
     */
    openLoginPage() {
      setTimeout(() => {
        this.$user.openLoginPage('web', Config.appEnv)
        this.open.auth = false
      }, 0)
    },

    /**
     * Скачивает модель на которую кликнули.
     * Так же стоит проверка на то, что страница открыта в плагине
     * @param id - id файла
     */
    downloadModel (id) {
      const obj = this.modelData.files.find(file => file.id === id)
      if (this.apicad) {
        window.external.DownloadModel(obj.downloadModelJson)
      } else {
        window.open(`/modeldownload/${obj.id_model}/${obj.name}/0/`)
      }
    },
  },
}
